// Clear Data

export default (data, value) => {
  Object.keys(data).forEach(key => {
    if (value) {
      if (value === key) {
        data[key].value = ['select', 'image', 'file'].indexOf(data[key].type) > -1 ? null : ''
        data[key].error = null
      }
    } else {
      data[key].value = ['select', 'image', 'file'].indexOf(data[key].type) > -1 ? null : ''
      data[key].error = null
    }
  })
  return data
}
